import AddIcon from '@mui/icons-material/Add';
import { Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { WsButton } from 'wisestep-base';

import { useUserContext, useWorkspaceContext } from '../../../context';
export interface IAddAccountButton {
  url: string;
}

const AddAccountButton = ({ url }: IAddAccountButton) => {
  const user = useUserContext();
  const admin = useWorkspaceContext();
  const navigate = useNavigate();
  const workspaceUser = user?.workspaceUser?.authorities;
  const isAdmin = workspaceUser?.includes('ROLE_ADMIN') || admin.owns;
  const goToNativeSearchSettings = () => navigate(`${url}`);

  return (
    <>
      {isAdmin && (
        <Grid pt={2}>
          <WsButton startIcon={<AddIcon fontSize="small" />} onClick={goToNativeSearchSettings}>
            Add account
          </WsButton>
        </Grid>
      )}
    </>
  );
};

export default AddAccountButton;
